import { cloneDeep } from "lodash";
import { Template } from "../../common/types/Template";
import { SvodPlanFilterSettings } from "./settings/SvodPlanFilterSettings";
import { Classificator } from "../../common/types/Classificator";
import { Option } from "../../common/types/Option";
import { MeasureUnit, PlanType, PaymentType, Segmentation } from "../../common/types/roots/fields";
import { allClassificationTypesOptions, allDataSourcesOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allStatusOptions, allPFOptions, allSvodTypes, allBudgetTypesOptions, allMutuallyRedeemingOptions, allMutuallyRedeemingLevelOptions, allSegmentationOptions, allPaymentTypesOptions, allPlanOptions, allMeasureUnitsOptions, allDevelopTypesOptions } from "../../common/baseOptions";
import { SvodPlanFilterOptions } from "./options/SvodPlanFilterOptions";
import { Draggable } from "../../common/types/Draggable";

export const allIncomeClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

export const allExpenseClassificators: Classificator[] = [
    { key: 'gr', active: true, selected: [] },
    { key: 'pgr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]

const tempSettings: SvodPlanFilterSettings = {
    // Base:
    reportName: 'SVOD-PLAN',
    reportType: 'REGULATED',
    classificationType: 'INCOMES_OR_EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'YEAR',
    mutuallyRedeeming: 'WITHOUT',
    svodType: 'APPROVED',
    year: (new Date().getFullYear()),
    region: '',
    planType: 'PF',
    typePF: 'IPF',
    typePFComponent: 'PAYMENTS',
    gu: '',
    gu261: '',
    statuses: ['39'],
    incomes: cloneDeep(allIncomeClassificators),
    expenses: cloneDeep(allExpenseClassificators),
    measureUnit: 'TENGE',
    roundUpTo: null,
    date: '',
    budgetTypes: [],
    mutuallyRedeemingLevels: [],
    calcCurPeriod: false,
    showTransferts: false,
    disableRemainCurPeriod: false,
    segmentations: [],
    developType: null,
    msuAggregation: false
}

export const svodPlanBaseTemplate: Template = {
    id: null,
    name: 'Сводный план',
    excelName: null,
    description: null,
    category: '40',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const svodPlanFilterOptions: SvodPlanFilterOptions = {
    // Base:
    key: 'SVOD-PLAN',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    regions: [],
    planTypes: cloneDeep(allPlanOptions),
    typePFs: cloneDeep(allPFOptions),
    typePFComponent: cloneDeep(allPaymentTypesOptions),
    gu: [],
    gu261: [],
    statuses: cloneDeep(allStatusOptions),
    incomes: cloneDeep(allIncomeClassificators),
    expenses: cloneDeep(allExpenseClassificators),
    svodTypes: cloneDeep(allSvodTypes),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    segmentations: cloneDeep(allSegmentationOptions),
    developTypes: cloneDeep(allDevelopTypesOptions)
}